"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _dealerDetailsHours = _interopRequireDefault(require("../../styles/dealer-details-hours.css"));
var _checkProps = _interopRequireDefault(require("../../utils/checkProps"));
var dataUtils = new _mmcDataUtilities["default"]();
var handleNestedProp = dataUtils.handleNestedProp;
var DepartmentHoursListItem = function DepartmentHoursListItem(_ref) {
  var hoursInfo = _ref.hoursInfo,
    theme = _ref.theme;
  if (!(0, _checkProps["default"])(hoursInfo)) {
    return /*#__PURE__*/_react["default"].createElement("tr", {
      className: _dealerDetailsHours["default"].hoursListItem
    }, /*#__PURE__*/_react["default"].createElement("th", {
      className: theme ? theme.smallType : ''
    }, hoursInfo.dayOfTheWeek ? hoursInfo.dayOfTheWeek + " " : null), /*#__PURE__*/_react["default"].createElement("th", {
      className: theme ? theme.smallType : ''
    }, hoursInfo.openTime ? "" + hoursInfo.openTime : ''));
  }
  return null;
};
DepartmentHoursListItem.defaultProps = {
  hoursInfo: {
    dayOfTheWeek: ''
  }
};
var _default = DepartmentHoursListItem;
exports["default"] = _default;